import {TOKEN_CREATED} from '../actions/tokenActions'

const initialState = {
    token: null
}

const tokenReducer =(state = initialState, action:any) => {
    switch (action.type) {
        case TOKEN_CREATED: {
            return action.payload
        }
        default:
            return state
    }
}
export default tokenReducer;